import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TaskService } from 'src/app/_services/task/task.service';
import { ActionItemsGridRowRendererComponent } from 'src/app/components/_shared/action-items-grid-row-renderer/action-items-grid-row-renderer.component';
import { ProjectTaskService } from 'src/app/_services/project_task/project-task.service'
import { ProjectService } from 'src/app/_services/project/project.service';
import { ProjectStructureService } from 'src/app/_services/projectStructure/projectStructure.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-task-v2',
  templateUrl: './task-v2.component.html',
  styleUrls: ['./task-v2.component.scss']
})
export class TaskV2Component implements OnInit {

  tenantId: string;
  form: FormGroup;
  taskForm;
  taskOwnerDropdown: any[] = [];
  projectDropdownList: any[] = [];
  partList: any[] = [];
  taskList: any[] = [];
  activityId: any;
  projectsData: any;
  userDetails: any;
  users: any;
  currentProjectId: any;
  parentProjectId: any;
  ProjecttaskId: any;
  taskDropdownList: any[] = [];
  projectTaskId: any;
  isPMOLeadORManager: boolean = false;
  isAdministrator: boolean = false;
  isPMOAdmin: boolean = false;
  projectName: any;
  taskName: any;
  minStartDate: any;
  minEndDate: any;

  rowData: any;   // row data and column definitions
  public columnDefs: ColDef[];
  modeAction: number = 1 //1 - create // 2 - update
  private api: GridApi; // gridApi and columnApi 
  private columnApi: ColumnApi;
  gridLength = 0;
  defaultColDef: any;
  rowSelection: any
  selectedCheckboxData: any[] = [];
  deleteConfirmationMsg = 'Are you sure you want to delete';
  sampleGridFrameworkComponents: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private snackBar: MatSnackBar,
    private storageService: LocalStorageService,
    private route: ActivatedRoute,
    private taskService: TaskService,
    private projecttaskService: ProjectTaskService,
    private projectStructureService: ProjectStructureService,
    private projectService: ProjectService,
    private datePipe: DatePipe,
  ) {
    this.defaultColDef = {
      flex: 1,
      minWidth: 100,
      resizable: true,
    };
    this.rowSelection = 'multiple';
    this.columnDefs = this.createColumnDefs();

    this.sampleGridFrameworkComponents = {
      actionRowRendererComponent: ActionItemsGridRowRendererComponent
    };

    this.form = this.formBuilder.group({
      file: ['', Validators.required]
    });

    this.taskForm = new FormGroup({
      id: new FormControl(''),
      projectV2TaskName: new FormControl(''),
      projectV2Id: new FormControl(''),
      projectV2Name: new FormControl("",[Validators.required]),
      projectV2Code: new FormControl(''),
      partList: new FormControl("",[Validators.required]),
      startDate: new FormControl("",[Validators.required]),
      endDate: new FormControl("",[Validators.required]),
      taskOwnerId: new FormControl(''),
      taskOwnerName: new FormControl("",[Validators.required]),
      status: new FormControl("",[Validators.required]),
      description: new FormControl(''),
      estimatedHours: new FormControl(''),
      plannedStartDate: new FormControl(''),
      plannedEndDate: new FormControl(''),
      plannedStatus: new FormControl(''),
      predecessorProjectV2TaskId: new FormControl(''),
      predecessorProjectV2TaskName: new FormControl(''),
      successorProjectV2TaskId: new FormControl(''),
      successorProjectV2taskName: new FormControl(''),
      completionPercentage: new FormControl(''),
    });

  }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.userDetails = JSON.parse(this.storageService.get('currentUser'));
    this.isAdministrator = this.userDetails.roles.includes('RoleAdministrator');
    this.isPMOAdmin = this.userDetails.roles.includes('RolePmoAdministrator');
    this.currentProjectId = this.route.snapshot.queryParamMap.get('projectID');
    this.parentProjectId = this.route.snapshot.queryParamMap.get('parentId');

    this.getProjectResource();
    this.getProjectById(this.currentProjectId);
    this.getTaskForCurrentProject();
    // this.getTask();
    this.getPartList();
  }

  // one grid initialisation, grap the APIs and auto resize the columns to fit the available space  
  onGridReady(params): void {
    this.api = params.api;
    this.columnApi = params.columnApi;
    this.api.sizeColumnsToFit();
  }

  // create column definitions  
  private createColumnDefs() {
    return [
      {
        headerName: 'Task Name',
        field: 'projectV2TaskName',
        filter: true,
        editable: false,
        sortable: true,
        headerCheckboxSelection: this.isFirstColumn,
        checkboxSelection: this.isFirstColumn,
      },
      {
        headerName: 'Resource Name',
        field: 'taskOwnerName',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Part List',
        field: 'partList',
        filter: true,
        editable: false,
        sortable: true,
        hide: true
      },
      {
        headerName: 'Start Date',
        field: 'startDate',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'EndDate',
        field: 'endDate',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Estimated Time(Hrs)',
        field: 'estimatedHours',
        filter: true,
        editable: false,
        sortable: true
      },
      {
        headerName: "Completion %",
        valueGetter: function (params) {
          return params.data.completionPercentage + '%';
        },
        filter: true,
        editable: false,
        sortable: true,
        hide: false
      },
      {
        headerName: 'Status',
        field: 'status',
        cellStyle: (params) => {
          if (params.value === 'Open' || params.value === 'open') {
            return { color: 'green', 'font-weight': 'bold' };
          } else if (params.value === 'Close' || params.value === 'close') {
            return { color: 'blue', 'font-weight': 'bold' };
          }
          return null;
        },
        filter: true,
        editable: false,
        sortable: true,
        hide: false,
      },
      {
        headerName: 'Description',
        field: 'description',
        filter: true,
        editable: false,
        sortable: true,
        hide: true,
      }
    ]
  }

  onSelectionChanged(event) {
    this.selectedCheckboxData = []
    let select = event.api.getSelectedNodes();
    for (let item of select) {
      this.selectedCheckboxData.push(item.data)
    }
  }

  isFirstColumn(params) {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  }

  createOpenModal() {
    this.modeAction = 1;
    this.taskForm.reset();
    this.taskForm.patchValue({
      id: '',
      projectV2TaskName: '',
      projectV2Name: this.projectName,
      projectV2Code: '',
      partList: '',
      startDate: '',
      endDate: '',
      taskOwnerName: '',
      status: '',
      description: '',
      estimatedHours: '',
      plannedStartDate: '',
      plannedEndDate: '',
      plannedStatus: '',
      predecessorProjectV2TaskName: '',
      successorProjectV2taskName: '',
      completionPercentage: '',
    });
  }

  editOpenModal() {
    this.modeAction = 2;
    this.projectTaskId = this.selectedCheckboxData[0].id;
    this.taskForm.patchValue(this.selectedCheckboxData[0]);
    this.taskForm.value.projectV2Name = this.selectedCheckboxData[0].projectV2Id + " . " + this.selectedCheckboxData[0].projectV2Name;
    this.taskForm.value.taskOwnerName = this.taskForm.value.taskOwnerId + " . " + this.taskForm.value.taskOwnerName;
    this.taskForm.value.estimatedHours = this.taskForm.value.estimatedHours;
    this.taskForm.value.predecessorProjectV2TaskName = this.taskForm.value.predecessorProjectV2TaskId + " . " + this.taskForm.value.predecessorProjectV2TaskName;
    this.taskForm.value.successorProjectV2taskName = this.taskForm.value.successorProjectV2TaskId + " . " + this.taskForm.value.successorProjectV2taskName;
    this.taskForm.patchValue(this.taskForm.value);
  }

  deleteOpenModal() {
    this.deleteConfirmationMsg = 'Are you sure you want to delete'
    for (let i in this.selectedCheckboxData) {
      if (+i === 0) this.deleteConfirmationMsg += ` ${this.selectedCheckboxData[i].taskOwnerName} ${this.selectedCheckboxData[i].name}`;
      else if (this.selectedCheckboxData.length === +i + 1) this.deleteConfirmationMsg += ` & ${this.selectedCheckboxData[i].taskOwnerName} ${this.selectedCheckboxData[i].name}`;
      else this.deleteConfirmationMsg += ` , ${this.selectedCheckboxData[i].taskOwnerName} ${this.selectedCheckboxData[i].name}`;
    }
  }

  // Pop-up message
  openSnackBar(message: string) {
    this.snackBar.open(message, 'Close', { duration: 3000 });
  }

  backToMyProjectV2() {
    if (this.parentProjectId) {
      this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/sub-project-v2'], { queryParams: { projectID: this.parentProjectId } });
    } else {
      this.router.navigate([this.tenantId + '/dashboard/project/project-list-v2/myproject-v2']);
    }
  }

  openProjectTab(param) {
    if (this.parentProjectId) {
      this.router.navigate([this.tenantId + `/dashboard/project/project-list-v2/${param}`], { queryParams: { projectID: this.currentProjectId, parentId: this.parentProjectId } }); // pass current project id as parameter
    }
    else {
      this.router.navigate([this.tenantId + `/dashboard/project/project-list-v2/${param}`], { queryParams: { projectID: this.currentProjectId } }); // pass current project id as parameter
    }
  }

  getProjectById(id) {
    this.taskService.getProjectV2ForTask(id).subscribe((response: any) => {
      if(response.projectManagerId === this.userDetails.id || response.projectLeadId === this.userDetails.id){
        this.isPMOLeadORManager = true;
      }
      else if(this.parentProjectId){
          this.projectService.getProjectV2(this.parentProjectId).subscribe((response2: any) => {
            if(response.projectManagerId === this.userDetails.id || response.projectLeadId === this.userDetails.id){
              this.isPMOLeadORManager = true;
            }
          });
        }

      this.taskForm.value.projectName = id + " . " + response.projectName;
      this.projectName = id + " . " + response.projectName
      let project = this.taskForm.value.projectName;
      this.taskForm.patchValue(this.taskForm.value);

      this.minStartDate = this.datePipe.transform(response.startDate, 'yyyy-MM-dd');
      this.minEndDate = this.datePipe.transform(response.endDate, 'yyyy-MM-dd');

      this.activityId = response.activityId;
      this.getTask();
    }, error => {
      this.openSnackBar(error);
    })
  }

  getTaskForCurrentProject() {
    this.taskService.getAllProjectTaskByProjectIdV2(this.currentProjectId).subscribe((response: any) => {
      this.rowData = response;
      for (let item of response) {
        this.taskDropdownList.push(`${item.id} . ${item.projectV2TaskName}`);
      }
    });
  }

  getProjectResource() {
    this.taskOwnerDropdown = []
    this.taskService.getProjectResourcesByProjectIdV2(this.currentProjectId).subscribe((response: any) => {
      this.taskOwnerDropdown = response.map((item: any) => `${item.userId} . ${item.userName}`);
    });
  }

  getTask(){
    this.taskList = [];
    this.projectStructureService.getTaskDropdownByActivity(this.activityId).subscribe((response: any) => {
      for (let item of response) {
        this.taskList.push(`${item.taskDropdownName}`);
      }
    });
  }

  getPartList() {
    this.partList = [];
    this.projecttaskService.getPartList(this.currentProjectId).subscribe((response: any) => {
      if (response) {
        for (let item of response) {
          this.partList.push(`${item.partList}`);
        }
      }
    });
  }

  createProjectTask() {
    let taskOwnersData: String;
    taskOwnersData = this.taskForm.get('taskOwnerName').value.toString().replaceAll(",", " , ");
    let data = {
      taskOwners: taskOwnersData,
      // taskOwnerId: this.taskForm.get('taskOwnerName').value?.toString().split(' . ')[0],
      projectV2TaskName: this.taskForm.get('projectV2TaskName').value,
      projectV2Id: parseInt((this.taskForm.get('projectV2Name').value).toString().substring(0, ((this.taskForm.get('projectV2Name').value).toString().indexOf('.')))),
      startDate: this.taskForm.get('startDate').value,
      endDate: this.taskForm.get('endDate').value,
      predecessorProjectV2TaskId: this.taskForm.get('predecessorProjectV2TaskName').value?.split(' . ')[0],
      successorProjectV2TaskId: this.taskForm.get('successorProjectV2taskName').value?.split(' . ')[0],
      partList: this.taskForm.get('partList').value,
      description: this.taskForm.get('description').value,
      estimatedHours: this.taskForm.get('estimatedHours').value,
      status: this.taskForm.get('status').value,
      plannedStartDate: this.taskForm.get('plannedStartDate').value,
      plannedEndDate: this.taskForm.get('plannedEndDate').value,
      plannedStatus: this.taskForm.get('plannedStatus').value,
      completionPercentage: this.taskForm.get('completionPercentage').value
    }
    this.taskService.createBulkProjectTasksV2(data).subscribe(((response: any) => {
      this.getTaskForCurrentProject();
      $('#closeTaskModal').trigger("click");
    }));
  }

  updateProjectTask() {
    let data = {
      taskOwnerId: this.taskForm.get('taskOwnerName').value?.toString().split(' . ')[0],
      projectV2TaskName: this.taskForm.get('projectV2TaskName').value,
      projectV2Id: parseInt((this.taskForm.get('projectV2Name').value).toString().substring(0, ((this.taskForm.get('projectV2Name').value).toString().indexOf('.')))),
      startDate: this.taskForm.get('startDate').value,
      endDate: this.taskForm.get('endDate').value,
      predecessorProjectV2TaskId: this.taskForm.get('predecessorProjectV2TaskName').value?.split(' . ')[0],
      successorProjectV2TaskId: this.taskForm.get('successorProjectV2taskName').value?.split(' . ')[0],
      partList: this.taskForm.get('partList').value,
      description: this.taskForm.get('description').value,
      estimatedHours: this.taskForm.get('estimatedHours').value,
      status: this.taskForm.get('status').value,
      plannedStartDate: this.taskForm.get('plannedStartDate').value,
      plannedEndDate: this.taskForm.get('plannedEndDate').value,
      plannedStatus: this.taskForm.get('plannedStatus').value,
      completionPercentage: this.taskForm.get('completionPercentage').value
    }
    this.taskService.updateProjectTasksV2(data, this.projectTaskId).subscribe(response => {
      this.getTaskForCurrentProject();
      $('#closeTaskModal').trigger("click");
    });
  }

  deleteProjectTaskListV2() {
    this.taskService.deleteProjectTasksV2(this.selectedCheckboxData[0].id).subscribe(() => {
      this.getTaskForCurrentProject();
      this.selectedCheckboxData = []
      $('#closeModalDelete').click();
    });
  }

  // getter for easy access to form fields
  get f() {
    return this.taskForm.controls;
  }

}